import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { BBResponseContainer } from "../carrier/response-container";
import { SplitRequest } from "./split-request";
import { tap, timeout } from 'rxjs/operators';

@Injectable()
export class ContainerSplitService {


    constructor(private http: HttpClient) {
    }

    /**
     * @description to generate and print barcodes
     * @param splitRequest object
    */
    generateBarcodes(splitRequest: SplitRequest): Observable<BBResponseContainer> {

        let url = environment.BB_SEQUENCING_SERVICE_URL + 'containerSplit/generateBarcodes'
        return this.http.post<BBResponseContainer>(url, splitRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

     /**
     * @description to process all steps of Splitting process
     * @param splitRequest object
    */
    processSplitContainers(splitRequest: SplitRequest): Observable<BBResponseContainer> {

        let url = environment.BB_SEQUENCING_SERVICE_URL + 'containerSplit'
        return this.http.post<BBResponseContainer>(url, splitRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    /**
     * @description to generate hamilton fle for splitting
     * @param splitRequest object
    */
    public generateHamiltonFile(splitRequest: SplitRequest): Observable<any> {

        let url = environment.BB_SEQUENCING_SERVICE_URL + 'containerSplit/generateHamitonFile'
        return this.http.post(url, splitRequest, {responseType:'blob'}).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }
}
